<template>
  <v-container fluid class="pa-6 container-background">

    <!-- HEADER -->
    <v-card class="main-card pa-6 mb-6">
      <div class="d-flex align-center justify-space-between flex-wrap">

        <div>
          <h1 class="main-title">
            <v-icon color="rgb(204 33 40)" class="mr-2">
              mdi-qrcode
            </v-icon>

            Publicación y código QR
          </h1>

          <p class="main-subtitle">
            Utilice el código QR o el enlace único para que sus clientes
            puedan autogestionar el registro y consentimiento de Habeas Data.
          </p>
        </div>

      </div>
    </v-card>
    

    <v-row>

      <!-- CONFIG QR -->
      <v-col cols="12" md="7">

        <v-card class="section-card pa-6">

          <div class="section-header">
            <div class="section-icon">
              <v-icon color="white">
                mdi-qrcode-scan
              </v-icon>
            </div>

            <div>
              <h2 class="section-title">
                Configuración QR
              </h2>

              <p class="section-subtitle">
                Personalice el contenido visual del código QR.
              </p>
            </div>
          </div>

          <v-form
            ref="form"
            v-model="formValid"
            class="mt-6"
          >

            <!-- TÍTULO -->
            <div>
              <label class="custom-label">
                Ingrese el título que requiere que se imprima con el QR
              </label>

              <v-text-field
                outlined
                dense
                placeholder="Ej: Título QR"
                v-model="formTitleQR"
                :rules="[rules.required]"
                class="custom-input"
              />
            </div>

            <!-- MENSAJE -->
            <div class="mt-5">
              <label class="custom-label">
                Ingrese el mensaje que requiere se imprima con el QR en la parte inferior.
              </label>

              <v-text-field
                outlined
                dense
                placeholder="Ej: Escanéame para registrarte"
                v-model="formMessageQR"
                :rules="[rules.required]"
                class="custom-input"
              />
            </div>

          </v-form>

        </v-card>

      </v-col>

      <!-- PREVIEW QR -->
      <v-col cols="12" md="5">

        <v-card class="preview-card pa-6">

          <div class="d-flex align-center mb-4">
            <v-icon
              color="rgb(204 33 40)"
              class="mr-2"
            >
              mdi-eye-outline
            </v-icon>

            <h3 class="preview-title">
              Vista previa QR
            </h3>
          </div>

          <!-- QR -->
          <div
            class="qr-preview"
            ref="printArea"
          >

            <div class="qr-title">
              {{ formTitleQR || 'Título QR' }}
            </div>

            <img
              :src="imageUrl"
              alt="QR"
              class="qr-image"
            />

            <div class="qr-footer">
              {{ formMessageQR || 'Escanéame para registrarte' }}
            </div>

          </div>

        </v-card>

      </v-col>

      <!-- URL -->
      <v-col cols="12">

        <v-card class="section-card pa-6 mt-2">

          <div class="section-header mb-5">

            <div class="section-icon">
              <v-icon color="white">
                mdi-link-variant
              </v-icon>
            </div>

            <div>
              <h2 class="section-title">
                Enlace directo
              </h2>

              <p class="section-subtitle">
                Este enlace es único para su comercio.
              </p>
            </div>

          </div>

          <v-text-field
            outlined
            readonly
            prepend-inner-icon="mdi-web"
            append-icon="mdi-content-copy"
            label="URL de registro"
            v-model="formUrlDirect"
            class="custom-input"
            @click:append="copyUrl"
          />

        </v-card>

      </v-col>

    </v-row>

    <!-- ALERT -->
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">

        <v-alert
          v-if="showAlert"
          :type="alertType"
          border="left"
          colored-border
          elevation="2"
          class="my-4"
        >
          {{ alertMessage }}
        </v-alert>

      </v-col>
    </v-row>

    <!-- BUTTON -->
    <div class="d-flex justify-end mt-4">

      <v-btn
        color="rgb(204 33 40)"
        x-large
        elevation="2"
        rounded
        class="white--text px-10 font-weight-bold"
        @click="save"
      >
        <v-icon left>
          mdi-printer-outline
        </v-icon>

        Guardar e imprimir QR
      </v-btn>

    </div>

    <!-- LOADING -->
    <v-overlay :value="loading" opacity="0.6" z-index="9999">
      <v-progress-circular
        indeterminate
        size="64"
        color="rgb(204 33 40)"
      />
    </v-overlay>

  </v-container>
</template>


<script>
import axios from "axios";
import { environment } from "@/data/environment";
export default {
  name: "UserRolesPermissions",
  data() {
    return {
      formTitleQR: null,
      formMessageQR: null,
      formUrlDirect: null,
      qr_path: null,
      imageUrl: environment.HIOPOSWEBSERVICES + "/images/no-qr-code.webp",
      showAlert: false,
      alertMessage: "",
      alertType: "success",
      loading: false,
      formValid: false,
      rules: {
        required: (v) => !!v || "Este campo es obligatorio",
      },
    };
  },
  mounted() {
    this.getFormCompany();
    this.getTitleAndDescription();
  },
  methods: {
    async getFormCompany() {
      try {
        this.loading = true;
        let idCompany = JSON.parse(
          atob(localStorage.getItem("uid"))
        ).idcompania;
        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/habeas-data/get-form-by-company`,
          {
            idCompany: idCompany,
          }
        );

        if (response.data.error) {
          this.setAlert("error", response.data.message);
        } else {
          this.formUrlDirect = response.data.data.url_form;
          this.imageUrl = environment.HIOPOSWEBSERVICES +
                          "/" +
                          response.data.data.qr_path +
                          "?t=" +
                          Date.now();
          console.log(this.imageUrl);
        }
      } catch (error) {
        console.error("Error al obtener el formulario:", error);
      } finally {
        this.loading = false;
      }
    },
    async getTitleAndDescription() {
      try {
        this.loading = true;
        let idCompany = JSON.parse(
          atob(localStorage.getItem("uid"))
        ).idcompania;
        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/habeas-data/get-title-and-description`,
          {
            idCompany: idCompany,
          }
        );

        if (response.data.error) {
          this.setAlert("error", response.data.message);
        } else {
          const data = response?.data?.data;
          if (data) {
            this.formTitleQR = response.data.data.form_title_QR ?? "";
            this.formMessageQR = response.data.data.form_message_QR ?? "";
          }
        }
      } catch (error) {
        console.error(
          "Error al obtener el titulo y descripcion del QR:",
          error
        );
      } finally {
        this.loading = false;
      }
    },
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },
    async save() {
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        this.setAlert(
          "error",
          "Por favor complete todos los campos obligatorios."
        );
        return;
      }

      this.loading = true;

      const formData = new FormData();
      formData.append(
        "idCompany",
        JSON.parse(atob(localStorage.getItem("uid"))).idcompania
      );
      formData.append("formTitleQR", this.formTitleQR);
      formData.append("formMessageQR", this.formMessageQR);
      try {
        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/habeas-data/public-by-company-save`,
          formData
        );
        console.log(response);
        if (response.data.error) {
          this.setAlert("error", response.data.message);
        } else {
          this.formTitleQR = response.data.data.form_title_QR;
          this.formMessageQR = response.data.data.form_message_QR;
          this.setAlert("success", response.data.message);
          this.$nextTick(() => {
            this.printQR();
            this.getFormCompany();

          });
        }
      } catch (error) {
        console.error("Error guardando configuración:", error);
        this.setAlert("error", "Error al guardar la configuración.");
      } finally {
        this.loading = false;
      }
    },
    printQR() {
      const content = this.$refs.printArea.innerHTML;

      const win = window.open("", "_blank");

      win.document.write(`
    <html>
      <head>
        <title>Imprimir QR</title>
        <style>
          @page {
            size: A4;
            margin: 0;
          }

          body {
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .print-wrapper {
            text-align: center;
          }
          .qr-title {
            font-size: 25px;
            margin-bottom: 20px;
          }

          .qr-footer {
            font-size: 20px;
            margin-top: 20px;
          }

          img {
            width: 400px; /* 🔥 QR GRANDE */
            height: auto;
          }

        </style>
      </head>
      <body>
        <div class="print-wrapper">
          ${content}
        </div>
      </body>
    </html>
  `);

      win.document.close();
      win.focus();

      setTimeout(() => {
        win.print();
        win.close();
      }, 600);
    },
    async copyUrl() {
      try {
        await navigator.clipboard.writeText(this.formUrlDirect);
        this.setAlert("success", "URL copiada al portapapeles");
      } catch (e) {
        console.error(e);
        this.setAlert("error", "No se pudo copiar la URL");
      }
    }
  },
};
</script>


<style scoped>
.container-background {
  /* background: #f8fafc; */
  min-height: 100vh;
}

.main-card {
  border-radius: 18px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 14px rgba(0,0,0,.04);
}

.main-title {
  font-size: 30px;
  font-weight: 700;
  /* color: #1e293b; */
  display: flex;
  align-items: center;
}

.main-subtitle {
  /* color: #6b7280; */
  margin-top: 4px;
  font-size: 14px;
}

.info-card {
  border-radius: 16px;
  border: 1px solid #fde68a;
  background: #fffdf5;
}

.info-title {
  font-weight: 700;
  color: #92400e;
  margin-bottom: 4px;
}

.info-text {
  color: #78350f;
  font-size: 14px;
  line-height: 1.6;
}

.section-card {
  border-radius: 18px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 14px rgba(0,0,0,.04);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.section-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgb(204 33 40);
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  /* color: #1e293b; */
  margin: 0;
}

.section-subtitle {
  font-size: 14px;
  /* color: #6b7280; */
  margin-top: 4px;
}

.custom-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  /* color: #374151; */
}

.helper-text {
  /* color: #6b7280; */
  font-size: 12px;
  line-height: 1.5;
}

.preview-card {
  border-radius: 18px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 14px rgba(0,0,0,.04);
}

.preview-title {
  font-size: 20px;
  font-weight: 700;
  /* color: #1e293b; */
}

.qr-preview {
  background: #f9fafb;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e5e7eb;
  text-align: center;
}

.qr-title {
  font-size: 20px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 20px;
}

.qr-image {
  width: 240px;
  max-width: 100%;
  object-fit: contain;
}

.qr-footer {
  margin-top: 20px;
  font-size: 15px;
  color: #6b7280;
}

::v-deep .v-text-field--outlined fieldset {
  border-color: #d1d5db !important;
  border-radius: 12px;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: rgb(204 33 40) !important;
  border-width: 2px;
}

::v-deep .v-input input {
  font-size: 14px;
}

::v-deep .v-btn {
  text-transform: none;
  letter-spacing: .3px;
}
</style>
